import { shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const autoAssignmentRuleType = shape({
  id: string,
  jobTitle: string,
  department: string,
});
